import { API, authClient } from "../index";

// Comunidad del negocio (fase 2 de fidelización).

// Estado del programa del negocio y, si la propina es del tiper, su progreso.
export const getCommunityStatus = (businessId, { tiperId, tipId, lang } = {}) => {
  const params = new URLSearchParams();
  if (tiperId) params.set("tiperId", tiperId);
  if (tipId) params.set("tipId", tipId);
  if (lang) params.set("lang", lang);
  return authClient().get(
    `${API}/community/business/${businessId}/status?${params.toString()}`
  );
};

// Unirse a la comunidad tras pagar: { tiperId, tipId, accepted, consentVersion, language }.
export const joinCommunity = (businessId, payload) => {
  return authClient().post(`${API}/community/business/${businessId}/join`, payload);
};
